import { useQuery } from '@tanstack/react-query';

import { RealTimeData } from '~features/home/TopBanner/components/Realtime/hooks';
import { fetcher } from '~lib/api/fetch';

interface UseGetRecentCommentResponse {
  realTime: RealTimeData[];
}

export function useGetRealTimeList() {
  return useQuery<UseGetRecentCommentResponse>(['homeRealTime'], () =>
    fetcher('/api/company/realTime'),
  );
}
